
<template>
  <van-popup
    v-model="show"
    :overlay="false"
    z-index="2"
    position="bottom"
    :style="{ height: '100vh' }"
    :lock-scroll="false"
  >
    <div class="wrapper">
      <div class="block">
        <div class="button-close" @click="onCloseClick()">
          <img
            style="height: 19px"
            :src="require('../../../assets/imgs/icon/bottom-modal-close.png')"
          />
        </div>

        <div class="content-container">
          <div v-if="articleContent.contentTitle" class="article-content-title">
            {{ articleContent.contentTitle.replace(/&nbsp;/g, ' ') }}
          </div>
          <!-- <p class="article-content-snapshot" v-html="article.fullContent">

          </p>-->
          <article-content
            class="article-content-snapshot"
            :content="articleContent.fullContent"
          ></article-content>

          <div style="height: 50px; background-color: #fff"></div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import * as ActionTypes from "../../../store/action-types";
import ArticleContent from "../../../components/content/ArticleContent";
import { mapState } from "vuex";

export default {
  name: "ArticleReviewModal",
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },

    data: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  components: {
    ArticleContent,
  },
  computed: {
    ...mapState({
      articleContent: (state) => state.article.articleContent,
    }),
  },

  data() {
    return {
      show: true,
    };
  },
  watch: {},
  methods: {
    onCloseClick() {
      this.onClose();
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background-color: #00000066;
}

.block {
  position: absolute;
  bottom: 0;
  background-color: #fff;
  height: 70vh;
  width: 100%;
  padding-bottom: 50px;
  border-radius: 20px 20px 0 0;
}

.content-container {
  height: 100%;
  padding: 15px;
  text-align: left;
  overflow: auto;
}

.article-content-title {
  font-size: 18px;
  color: #333333;
  font-family: serif,SimSun,STSong;
  font-weight :bold
  margin: 5px 0;
  word-wrap: break-word;
}

.article-content-snapshot {
  padding-bottom: 10px;
  font-size: 14px;
}

.article-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  font-size: 11px;
  color: #999999;
  -webkit-transform-origin-x: 0;
  -webkit-transform: scale(0.9);
}

.text-level-desc {
  margin-top: 10px;
  font-size: 12px;
  transform: scale(0.9);
  color: #333333;
}

.button-close {
  text-align: center;
  margin: 10px;
}
</style>


// WEBPACK FOOTER //
// app/pages/article/component/ArticleReviewModal.vue